
import ResultsList from "../../components/results-list/results-list.component";
import React, { Component }  from 'react';
const DrinkList = () =>{
    return(
        <ResultsList />
    )

}

export default DrinkList;